// eslint-disable-next-line no-shadow
export enum Permission {
  CAN_CREATE_ADMIN = "CAN_CREATE_ADMIN",
  CAN_DELETE_ADMIN = "CAN_DELETE_ADMIN",
  CAN_CREATE_OWNER = "CAN_CREATE_OWNER",
  CAN_DELETE_OWNER = "CAN_DELETE_OWNER",
  CAN_ACCESS_BENEFITS_SECTION = "CAN_ACCESS_BENEFITS_SECTION",
  CAN_ACCESS_EMPLOYEES_SECTION = "CAN_ACCESS_EMPLOYEES_SECTION",
  CAN_ACCESS_ANALYTICS_SECTION = "CAN_ACCESS_ANALYTICS_SECTION",
  CAN_ACCESS_MISC_SETTINGS = "CAN_ACCESS_MISC_SETTINGS",
}

export class ManagerPermission {
  private permissions: Set<Permission>;

  constructor(permissions: Permission[] = []) {
    this.permissions = new Set(permissions);
  }

  addPermission(permission: Permission) {
    this.permissions.add(permission);
  }

  removePermission(permission: Permission) {
    this.permissions.delete(permission);
  }

  hasPermission(permission: Permission): boolean {
    return this.permissions.has(permission);
  }

  getAllPermissions(): Permission[] {
    return Array.from(this.permissions);
  }
}
